import Layout from "../elements/templates/Layout";
import Header from "../elements/organisms/Header";
import Helper from "../elements/organisms/Helper";

const NotFound = (props) => {
  return (
    <Layout>
      <Header />
      <div>NotFound</div>
      <Helper />
    </Layout>
  );
};

export default NotFound;
